import {
    DELETEEXPENSE_FAIL,
    DELETEEXPENSE_SUCCESS,
} from "../actionTypes";

const initialState = {
    user: null,
};

const deleteExpenseReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETEEXPENSE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case DELETEEXPENSE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default deleteExpenseReducer;
